export const convertToValidID = (text: string): string => {
    return text.toLowerCase().replace(/^[^a-z]+|[^\w:.-]+/gi, '');
};
